var _polygon, _polygon2, _polygon3, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnktLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.77 16.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "10.58 6.8 18.32 0.02 13.38 0.02 8.54 4.27 5.95 6.54 3.86 8.37 3.86 3.96 3.86 0.02 0.69 0.02 0 0.02 0 11.76 0 16.09 0 16.66 3.86 16.66 3.86 12.7 7.99 9.07 14.12 16.66 18.54 16.66 10.58 6.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "34.75 0.02 34.75 11.29 23.98 0.02 23.95 0 23.95 0.02 20.33 0.02 20.33 1.57 20.33 16.66 23.95 16.66 23.95 5.36 34.75 16.65 34.75 16.66 34.76 16.66 38.46 16.66 38.46 15.17 38.46 0.02 34.75 0.02"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "53.74 6.8 61.47 0.02 56.53 0.02 51.69 4.27 49.1 6.54 47.02 8.37 47.02 3.96 47.02 0.02 43.84 0.02 43.16 0.02 43.16 11.76 43.16 16.09 43.16 16.66 47.02 16.66 47.02 12.7 51.15 9.07 57.27 16.66 61.69 16.66 53.74 6.8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "73.88 0.02 70.02 0.02 63.14 0.02 63.14 3.49 70.02 3.49 70.02 7.82 70.02 9.04 70.02 16.66 73.88 16.66 73.88 9.04 73.88 7.82 73.88 3.49 80.77 3.49 80.77 0.02 73.88 0.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnktLogo);
export default __webpack_public_path__ + "static/media/knkt-logo.9e17f882f1b1b1cd371f079355a9ceb4.svg";
export { ForwardRef as ReactComponent };